import isBase64Image from "Common/componentUtils/isBase64Image";
import urlToBase64 from "Common/componentUtils/urlToBase64";
import { dxBaseStyles, dxDataGrid, yfilesBaseStyles, yfilesSelectedNodeStyles, yfilesTemplatesStyles } from "Components/theme";
import filter from "lodash/filter";
import forEach from "lodash/forEach";
import includes from "lodash/includes";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import reject from "lodash/reject";
import size from "lodash/size";
import some from "lodash/some";
import startsWith from "lodash/startsWith";
import { GraphComponent, Insets, Size, SvgExport } from "yfiles";
import { GRAPH_IS_EXPORTING_CLASS_NAME, NODE_GROUP_MAX_VISIBLE_ROWS_COUNT, ZOOM } from "../../constants";
import renderSvgToPng from "./renderSvgToPng";
import yFilesCss from "!!raw-loader!yfiles/yfiles.css";
import dxLightCss from "!!raw-loader!devextreme/dist/css/dx.light.css";
const cssStyleSheet = `
  ${dxLightCss}
  ${dxBaseStyles}
  ${dxDataGrid}
  ${yFilesCss}

  ${yfilesTemplatesStyles}
  ${yfilesBaseStyles}

  g ${yfilesSelectedNodeStyles}
`;
export default class ClientSideImageExport {
    constructor() {
        this.scale = 1;
        this.margins = new Insets(10);
    }
    async exportImage(graph, exportRect) {
        const exportComponent = new GraphComponent();
        exportComponent.graph = graph;
        if (exportRect) {
            exportComponent.contentRect = exportRect;
        }
        else {
            exportComponent.updateContentRect();
        }
        if (exportComponent === null || exportComponent === void 0 ? void 0 : exportComponent.div)
            exportComponent.div.classList.add(GRAPH_IS_EXPORTING_CLASS_NAME);
        const exporter = new SvgExport({
            worldBounds: exportComponent.contentRect,
            scale: this.scale,
            margins: this.margins,
            copyDefsElements: true,
            cssStyleSheet,
            zoom: ZOOM.DEFAULT
        });
        if (window.btoa != null) {
            exporter.encodeImagesBase64 = true;
            exporter.inlineSvgImages = true;
        }
        const nodes = graph.nodes.toArray();
        const regularNodes = filter(nodes, n => { var _a; return Boolean((_a = n.tag) === null || _a === void 0 ? void 0 : _a.NodeId); });
        const groupNodes = filter(nodes, n => { var _a; return Boolean((_a = n.tag) === null || _a === void 0 ? void 0 : _a.Nodes); });
        let imagesUpdated = 0;
        const toUpdateImgSrcInGroup = {};
        const groupNodeSourcesToUpdate = [];
        const groupsCount = groupNodes.length;
        forEach(groupNodes, n => {
            var _a;
            if (!((_a = n.tag) === null || _a === void 0 ? void 0 : _a.Nodes))
                return;
            const rows = filter(orderBy(n.tag.Nodes, ["NodeId"], ["desc"]).slice(0, NODE_GROUP_MAX_VISIBLE_ROWS_COUNT + 1), nodeSource => Boolean(nodeSource.NodeImage &&
                !startsWith(nodeSource.NodeImage, window.location.origin) &&
                !isBase64Image(nodeSource.NodeImage)));
            if (rows.length) {
                forEach(rows, r => {
                    toUpdateImgSrcInGroup[r.NodeImage] = "";
                });
                groupNodeSourcesToUpdate.push({ group: n, nodeIds: map(rows, "NodeId") });
            }
        });
        if (regularNodes.length) {
            await Promise.all(map(regularNodes, async (n) => {
                var _a;
                if (!((_a = n.tag) === null || _a === void 0 ? void 0 : _a.NodeId))
                    return;
                const nodeSource = n.tag;
                if (nodeSource.NodeImage &&
                    !isBase64Image(nodeSource.NodeImage) &&
                    !startsWith(nodeSource.NodeImage, window.location.origin) &&
                    !startsWith(nodeSource.NodeImage, "/")) {
                    await new Promise(resolve => {
                        urlToBase64(nodeSource.NodeImage, (res) => {
                            if (res) {
                                n.tag = { ...n.tag, NodeImage: res };
                                imagesUpdated += 1;
                            }
                            resolve(res);
                        });
                    });
                }
            }));
        }
        if (size(toUpdateImgSrcInGroup)) {
            await Promise.all(map(toUpdateImgSrcInGroup, async (_, imgSrc) => {
                await new Promise(resolve => {
                    urlToBase64(imgSrc, (res) => {
                        if (res) {
                            toUpdateImgSrcInGroup[imgSrc] = res;
                            imagesUpdated += 1;
                        }
                        resolve(res);
                    });
                });
            }));
            forEach(groupNodeSourcesToUpdate, g => {
                const nodesNotToUpdate = reject(g.group.tag.Nodes, n => includes(g.nodeIds, n.NodeId));
                const nodesToUpdate = map(filter(g.group.tag.Nodes, n => includes(g.nodeIds, n.NodeId)), n => ({
                    ...n,
                    NodeImage: n.NodeImage ? toUpdateImgSrcInGroup[n.NodeImage] || n.NodeImage : n.NodeImage
                }));
                g.group.tag = {
                    ...g.group.tag,
                    Nodes: [...nodesNotToUpdate, ...nodesToUpdate]
                };
            });
        }
        if (imagesUpdated) {
            exportComponent.updateVisual();
        }
        const svgElement = await exporter.exportSvgAsync(exportComponent);
        if (groupsCount > 0) {
            const getTables = () => Array.from(svgElement.getElementsByClassName("dx-datagrid"));
            let step = 0;
            while (step < 20 &&
                (getTables().length !== groupsCount ||
                    some(getTables(), t => !t.getElementsByClassName("dx-data-row").length))) {
                step++;
                await new Promise(res => {
                    setTimeout(res, 500);
                });
            }
        }
        return renderSvgToPng(svgElement, new Size(exporter.viewWidth, exporter.viewHeight), this.margins);
    }
}
